import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3714b794"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "course-info"
};
const _hoisted_2 = {
  class: "course-panel"
};
import { reactive, onMounted, watch, watchEffect, toRefs, ref } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import DetailsPanel from './DetailsPanel';
import Breadcrumb from '@/components/Breadcrumb';
import InformationCard from './InformationCard';
import { postCourseDetail, postImporventInformation, postJoinClass, postPreviewExecirse, coursePreRegister } from '@/api/courseDetail';
import { postUserOnLine } from '@/api/app';
import { handleToLogin } from '@/utils/router';
import { useUserStore } from '@/stores/user';
import { useAppStore } from '@/stores/app';
import { useRoute, useRouter } from 'vue-router';
export default {
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const ruleFormRef = ref();
    const form = reactive({
      name: '',
      mobile: '',
      collegeName: ''
    });
    const {
      id
    } = route.query;
    const user = useUserStore();
    const appData = useAppStore();
    const {
      headerFlag
    } = toRefs(user);
    const {
      isMobile
    } = toRefs(appData);
    const {
      userId,
      mobile
    } = user.userInfo;
    const validateMobile = (_, value, callback) => {
      const regex = /^1[3456789]\d{9}$/;
      if (!regex.test(value)) {
        callback(new Error('手机号格式错误'));
      } else {
        callback();
      }
    };
    const state = reactive({
      classId: id,
      courseInfo: {},
      buttonText: '',
      isAdd: false,
      disabledButton: false,
      kid: '',
      noLive: true,
      dialogExecrise: false,
      questionList: [],
      dialogFormVisible: false
    });
    const rules = reactive({
      collegeName: [{
        required: true,
        message: '请输入院校名称',
        trigger: 'blur'
      }, {
        min: 1,
        max: 20,
        message: '请输入20个字符以内',
        trigger: 'blur'
      }],
      name: [{
        required: true,
        message: '请输入姓名',
        trigger: 'blur'
      }, {
        min: 1,
        max: 10,
        message: '请输入10个字符以内',
        trigger: 'blur'
      }],
      mobile: [{
        required: true,
        message: '请输入手机号',
        trigger: 'blur'
      }, {
        validator: validateMobile,
        trigger: 'blur'
      }]
    });
    watch(() => state.flag, val => {
      state.flag = val;
    });
    watchEffect(() => {
      if (route.path === '/course/detail' && isMobile) {
        document.getElementById('app').style.minWidth = '100%';
      } else {
        document.getElementById('app').style.minWidth = '1300px';
      }
    });
    // 直播课点击直播相关按钮
    const handleToLive = async () => {
      const isInfo = await isImproventInfor();
      if (isInfo.success) {
        state.courseInfo.liveStatus === 'END' ? handleToPreview() : onLive(state.courseInfo.previewUrl);
      } else {
        messageBox(isInfo.message, '去完善信息').then(() => {
          onImprovent();
        }).catch(() => {});
      }
    };
    const handleSignUp = async () => {
      const res = await isOnLine();
      if (!res.success) {
        messageBox('未登录，登录后可预报名', '去登录').then(() => {
          handleToLogin();
        }).catch(() => {});
      } else {
        state.dialogFormVisible = true;
      }
    };
    // 点击加入学习/报名缴费按钮
    const toLearn = () => {
      if (state.courseInfo.learnStatus === false || !state.courseInfo.learnStatus) {
        if (state.courseInfo.coursePlayType === '1') {
          state.courseInfo.free === '1' ? learnPayCourse() : learnFreeCourse();
        } else {
          state.courseInfo.free === '1' ? learnPayCourse() : learnFreeCourse(state.noLive);
        }
      } else {
        state.courseInfo.coursePlayType === '1' ? learnJoinPayCourse() : learnJoinPayCourse(state.noLive);
      }
    };

    // 免费课程-录播、直播
    const learnFreeCourse = async key => {
      const res = await isOnLine();
      if (!res.success) {
        if (key) {
          messageBox('未登录，登录后可加入学习', '去登录').then(() => {
            handleToLogin();
          }).catch(() => {});
        } else {
          messageBox('未登录，登录后可报名学习', '去登录').then(() => {
            handleToLogin();
          }).catch(() => {});
        }
      } else {
        if (headerFlag.value) {
          const isInfo = await isImproventInfor();
          if (isInfo.success) {
            if (key) {
              if (state.isAdd) return handleToPreview();
            }
            const joinClass = await fetchJoinClass();
            if (joinClass.success === true) return joinClassButton();
          } else {
            messageBox(isInfo.message, '去完善信息').then(() => {
              onImprovent();
            }).catch(() => {});
          }
        } else {
          if (key) {
            if (state.isAdd) return handleToPreview();
          }
          const joinClass = await fetchJoinClass();
          if (joinClass.success === true) return joinClassButton();
        }
      }
    };

    // 付费课程-录播、直播
    const learnPayCourse = async () => {
      const res = await isOnLine();
      if (!res.success) {
        messageBox('未登录，登录后可报名学习', '去登录').then(() => {
          handleToLogin();
        }).catch(() => {});
      } else {
        // return ElMessage.error('暂未开通线上支付，请联系运营人员')
        router.push({
          path: '/course/detail/payment',
          query: {
            id: id
          }
        });
      }
    };

    // 已加入学习的付费课程（适配从后台导入学员）
    const learnJoinPayCourse = async key => {
      if (headerFlag.value) {
        const isInfo = await isImproventInfor();
        if (isInfo.success) {
          if (key) {
            handleToPreview();
          }
        } else {
          messageBox(isInfo.message, '去完善信息').then(() => {
            onImprovent();
          }).catch(() => {});
        }
      } else {
        if (key) {
          handleToPreview();
        }
      }
    };

    // 是否登录
    const isOnLine = () => {
      return postUserOnLine();
    };

    // 是否完善信息
    const isImproventInfor = () => {
      const req = {
        userId: userId
      };
      return postImporventInformation(req);
    };

    // 加入班级
    const fetchJoinClass = () => {
      const query = {
        courseId: id,
        userId: userId,
        mobile
      };
      if (!headerFlag.value) {
        query.isCheck = false;
      }
      return postJoinClass(query);
    };

    // 加入班级的按钮
    const joinClassButton = () => {
      if (state.courseInfo.free === '0' && state.courseInfo.coursePlayType === '0') {
        state.buttonText = '已加入，去学习';
        state.isAdd = true;
      } else if (state.courseInfo.free === '1' && state.courseInfo.coursePlayType === '0') {
        state.buttonText = '已缴费，去学习';
        state.isAdd = true;
      } else if (state.courseInfo.free === '0' && state.courseInfo.coursePlayType === '1') {
        state.buttonText = '已报名';
        fetchCourseDetail();
      } else if (state.courseInfo.free === '1' && state.courseInfo.coursePlayType === '1') {
        state.buttonText = '已缴费';
        fetchCourseDetail();
      }
    };

    // 去完善信息
    const onImprovent = () => {
      window.open(`${window.location.origin}/my/personal`);
    };

    // 去预览
    const handleToPreview = () => {
      const {
        id,
        contentId
      } = state.courseInfo;
      const kId = contentId ? `&kId=${contentId}` : '';
      // window.open(`/preview?cId=${id}${kId}`)
      router.push(`/preview?cId=${id}${kId}`);
    };

    // 课程详情
    function fetchCourseDetail() {
      const query = {
        id: state.classId,
        userId: userId
      };
      postCourseDetail(query).then(res => {
        if (res.success) {
          state.courseInfo = res.data;
        } else {
          ElMessage.error('该课程不存在，请稍后');
          router.push('/');
        }
      });
    }

    // 打开直播链接
    const onLive = url => {
      url ? window.open(url) : ElMessage.error('直播链接异常，稍后重试');
    };

    // 消息提示弹窗
    const messageBox = (message, toMessage) => {
      return ElMessageBox.alert(message, '提示', {
        confirmButtonText: toMessage
      });
    };
    const handlePreExecirse = async resourceId => {
      const req = {
        resourceId: resourceId
      };
      await postPreviewExecirse(req).then(res => {
        if (res.success) {
          if (res.data.groupList.length > 0) {
            const questionList = res.data.groupList;
            const flattenedQuestions = questionList.flatMap(group => group.questionVOList.flatMap(question => question));
            flattenedQuestions.forEach(ele => {
              ele.objective = ele.quObjectiveDataOptions;
              ele.content = ele.quQuestionContent.content;
              ele.attachments = ele.attachmentList;
            });
            state.questionList = flattenedQuestions;
            state.dialogExecrise = true;
          } else {
            ElMessage('该节下没有试题，无法预览!');
          }
        } else {
          ElMessage.error('该试题不存在');
        }
      });
    };
    const handleSave = formEl => {
      if (!formEl) return;
      formEl.validate(valid => {
        if (valid) {
          const req = {
            courseId: state.courseInfo.id,
            courseName: state.courseInfo.courseName,
            userId,
            name: form.name,
            mobile: form.mobile,
            collegeName: form.collegeName
          };
          coursePreRegister(req).then(res => {
            if (res.success) {
              state.dialogFormVisible = false;
              ElMessage.success('预报名成功!');
              fetchCourseDetail();
            } else {
              ElMessage.error(res.message);
            }
          });
        }
      });
    };
    const handleExeDialog = () => {
      state.dialogExecrise = false;
    };
    onMounted(() => {
      fetchCourseDetail();
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["course-detail", {
          'course-detail-pc': !_unref(headerFlag)
        }])
      }, [_createVNode(_unref(Breadcrumb)), _createElementVNode("div", _hoisted_1, [_createVNode(_unref(InformationCard), {
        courseInfo: state.courseInfo,
        buttonText: state.buttonText,
        disabledButton: state.disabledButton,
        onLearn: toLearn,
        onLive: handleToLive,
        onSignUp: handleSignUp
      }, null, 8, ["courseInfo", "buttonText", "disabledButton"])]), _createElementVNode("div", _hoisted_2, [_createVNode(_unref(DetailsPanel), {
        courseInfo: state.courseInfo,
        dialogExecrise: state.dialogExecrise,
        questionList: state.questionList,
        onPreExecirse: handlePreExecirse,
        onCloseExeDialog: handleExeDialog
      }, null, 8, ["courseInfo", "dialogExecrise", "questionList"])]), _createVNode(_component_el_dialog, {
        modelValue: state.dialogFormVisible,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => state.dialogFormVisible = $event),
        title: "预报名",
        class: "dialog-box"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: form,
          rules: rules,
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          "label-width": "80px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "院校名称",
            prop: "collegeName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.collegeName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.collegeName = $event),
              maxlength: "20",
              class: "input-width",
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "手机号",
            prop: "mobile"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.mobile,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.mobile = $event),
              class: "input-width",
              maxlength: "11",
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "姓名",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.name,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.name = $event),
              maxlength: "10",
              class: "input-width",
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[3] || (_cache[3] = $event => handleSave(ruleFormRef.value))
            }, {
              default: _withCtx(() => [_createTextVNode(" 确定 ")]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue"])], 2);
    };
  }
};